import React from 'react';
import { Switch } from 'react-router-dom';
import { BundleRoute } from '@saucelabs/sl-component-router';
import dynamic from '@redux-dynostore/react-redux';
import { attachReducer } from '@redux-dynostore/core';

import jobReducer from './reducers';

const importEmbeddedWrapper = () => import(/* webpackChunkName: "embedded-wrapper" */ './containers/EmbeddedWrapperContainer');

/*
 https://reacttraining.com/react-router/web/api/Route/path-string-string
 string[] as a path prop doesn't work oO
*/
const EmbeddedJobRoutes = () => (
  <Switch>
    <BundleRoute
      key="job-embed"
      exact
      load={importEmbeddedWrapper}
      path="/job-embed/:jobId"
    />
    <BundleRoute
      key="video-embed"
      exact
      load={importEmbeddedWrapper}
      path="/video-embed/:jobId"
    />
  </Switch>
);

export default dynamic(
  'apps.job', attachReducer(jobReducer),
)(EmbeddedJobRoutes);
export { EmbeddedJobRoutes };
